var _ellipse, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 32 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16,
    cy: 17,
    rx: 16,
    ry: 17,
    transform: "matrix(-1 0 0 1 32 0)",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8489_47358)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2895 9.5625C22.2336 9.5625 23 10.3768 23 11.3799V22.6201C23 23.6232 22.2336 24.4375 21.2895 24.4375H18.3783V18.8328H20.1994L20.5459 16.4324H18.3783V14.8747C18.3783 14.218 18.6811 13.5779 19.652 13.5779H20.6375V11.5343C20.6375 11.5343 19.7431 11.3722 18.888 11.3722C17.1028 11.3722 15.936 12.5218 15.936 14.6029V16.4324H13.9515V18.8328H15.936V24.4375H10.7105C9.76645 24.4375 9 23.6232 9 22.6201V11.3799C9 10.3768 9.76642 9.5625 10.7105 9.5625H21.2895V9.5625Z",
    fill: "#383A35"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8489_47358"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14.875,
    fill: "white",
    transform: "translate(9 9.5625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFace);
export default __webpack_public_path__ + "static/media/face.aa7ea8044b9144d88c7818ce25ad34ec.svg";
export { ForwardRef as ReactComponent };